import moment from 'moment';
import React from 'react';
import { numberWithCommas } from '../../../../../Utils/NumberToComma';
import './fInvoice.css'

function Invoice(props){

    let {debitNote} = props.data;

    const rednerTable = (item, index)=>{
        return(
            <div key={`entry-${index}`} style={{display: 'flex',alignItems:'center', justifyContent: 'space-evenly', margin: '15px 0px'}}>
                <div style={{width: '160px'}}>{item.desc}<br/>Code: {item.hsn} <br /> Service : {item.service} <br></br></div>
                <div style={{width: '100px',}}> {item.price ?numberWithCommas(item.price.toFixed(2)) +" / "+ item.unit :item.price +"/"+ item.unit}</div>
                <div style={{width: '100px',}}> {item.original_qtty.toFixed(2)}</div>
                {debitNote?<div style={{width: '100px',}}> {item.debitQty}</div>:null}
                <div style={{width: '100px',}}> {item.base_amt ?numberWithCommas(item.base_amt.toFixed(2)):item.base_amt}</div>
                <div style={{width: '100px'}}> {item.cessAmount ?numberWithCommas(item.cessAmount.toFixed(2)):0}</div>
                <div style={{width: '100px'}}> {item.tax_amt ?numberWithCommas(item.tax_amt.toFixed(2)):numberWithCommas(item.tax_amt)}</div>
                <div style={{width: '100px', textAlign: 'right'}}> {item.amount ?numberWithCommas(item.amount.toFixed(2)):numberWithCommas(item.amount)}</div>
            </div>
        )
    }
    
    let partial = 0;

    props.data.allSettlement.forEach(val=>{
         if(val.transferred) {
            partial = partial+val.amount
         }
    })


 return(
        <div className='FadeRight-Effect' style={{width: '100%', fontSize: '12px'}}>
        <div style={{textAlign: 'center', fontSize: '22px', fontWeight: 'bold'}}>View Debit Note</div>
            {
              
                props.data.discount?
                    <p style={{
                        top:10,
                        left:0,
                        padding:'12px 30px',
                        position:'absolute',
                        background:"green",
                        color:'var(--white-color)',
                        fontSize:11
                    }}>
                        Discounted at {props.data.discount} %
                    </p>:undefined
            }
            {
              
              props.data.rcVendor?
                  <p style={{
                      top:40,
                      left:0,
                      padding:'12px 30px',
                      position:'absolute',
                      background:'var(--primary-color)',
                      color:'var(--white-color)',
                      fontSize:11
                  }}>
                      RCM Invoice
                  </p>:undefined
          }
        <div style={{border: '1px solid var(--border-color)', padding: '20px', borderRadius: '15px', marginTop: '30px'}}>
            <div style={{display: 'flex', justifyContent: 'space-between'}}>
                <div>
                    <b>Vendor</b><br/>
                    {props.data.vendor}<br/>
                    Email: {props.data.email}<br/>
                    GSTIN: {props.data.vendor_id}
                </div>
                <div style={{textAlign: 'right'}}>
                Date: {moment(props.data.date).format('DD-MM-YYYY')}<br/>
                {props.data.due?<>Due Date: {moment(props.data.due).format('DD-MM-YYYY')}<br/></>:<></>}
                Invoice ID: {props.data.invoice_id}<br/>
                Bill Number : {props.data.bill_number}<br/>
                </div>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-between', marginTop: '20px'}}>
                <div style={{paddingRight: '20px'}}>
                    <b>Billing Address</b><br/>
                    {props.data.bill_to.title?<span>{props.data.bill_to.title}<br></br></span>:null}
                    {props.data.bill_to.registeredName?<span>{props.data.bill_to.registeredName}<br></br></span>:null}
                    {props.data.bill_add}<br/>
                    {props.data.bill_to.gstin?<span>{props.data.bill_to.gstin}<br></br></span>:null}

                </div>
                <div style={{textAlign: 'right', paddingLeft: '20px'}}>
                    <b>Shipping Address</b><br/>
                    {props.data.ship_to.title?<span>{props.data.ship_to.title}<br></br></span>:null}
                    {props.data.ship_to.registeredName?<span>{props.data.ship_to.registeredName}<br></br></span>:null}
                    {props.data.ship_add}<br></br>
                    {props.data.ship_to.gstin?<span>{props.data.ship_to.gstin}<br></br></span>:null}
                </div>
            </div>
        </div>

        <div style={{display: 'flex', justifyContent: 'space-evenly', marginTop: '30px', fontWeight: 'bold', paddingBottom: '10px', borderBottom: '1px solid var(--border-color)'}}>
            <div style={{width: '160px'}}>Desciption</div>
            <div style={{width: '100px',}}>Price / unit</div>
            <div style={{width: '100px',}}>Qty</div>
            {debitNote?<div style={{width: '100px',}}>Debit Qty</div>:null}
            <div style={{width: '100px',}}>Base Amt</div>
            <div style={{width: '100px',}}>Cess Amt</div>
            <div style={{width: '100px'}}>Tax Amt</div>
            <div style={{width: '100px', textAlign: 'right'}}>Amount (INR)</div>

        </div>
       {
           props.data.table.map(rednerTable)
       }
        <div className='invoice-taxes'>
            <div className='wrap'>
                <div>SGST / UTGST: </div>
                <div> {props.data.sgst ? numberWithCommas(props.data.sgst.toFixed(3)):0}</div>
            </div>
        </div>
        <div className='invoice-taxes'>
            <div className='wrap'>
                <div>CGST: </div>
                <div> {props.data.cgst ? numberWithCommas(props.data.cgst.toFixed(3)): 0}</div>
            </div>
        </div>
        <div className='invoice-taxes'>
            <div className='wrap'>
                <div>IGST: </div>
                <div> {props.data.igst ?numberWithCommas(props.data.igst.toFixed(2)):numberWithCommas(props.data.igst)}</div>
            </div>
        </div>

        <div className='invoice-taxes'>
            <div className='wrap'>
                <div>Base Amt: </div>
                <div> {numberWithCommas(props.data.total_base.toFixed(2))}</div>
            </div>
        </div>
       
        <div className='invoice-taxes' style={{fontWeight: 'bold'}}>
            <div className='wrap'>
                <div>Tax Amt: </div>
                <div>{(props && props.data && props.data.total_tax)?numberWithCommas(props.data.total_tax.toFixed(2)):0}</div>
            </div>
        </div>
            
        <div className='invoice-taxes'>
            <div className='wrap'>
                <div>Total Amt: </div>
                <div> {numberWithCommas(props.data.total_amt.toFixed(2))}</div>
            </div>
        </div>
  
        <div style={{display: 'flex', padding: '10px 0px', fontWeight: 'bold', borderTop: '1px solid var(--border-color)', borderBottom: '1px solid var(--border-color)'}}>
            <div style={{flexGrow: 1}}>Total Vendor Payable Amount: </div>
            <div style={{width: '100px', textAlign: 'right'}}> {numberWithCommas((props.data.payable_amt).toFixed(2))}</div>
        </div>
    </div>
 )
}



export default Invoice;
